/**
 * Tuning constants for scoring and grading.
 *
 * Every value here is expected to change once real test sessions exist
 * (see PLAN.md, "Prototype P1"). Keep them in these objects rather than
 * duplicating literals across the scoring code.
 */
export const DEFAULT_SCORING_CONFIG = {
    expectedLagMs: 200,
    timingWindowMs: 200,
    earlySigmaMs: 120,
    lateSigmaMs: 160,
    evaluationDelayMs: 550,
    playerBufferMs: 1000,
    staticPoseWeight: 0.8,
    motionWeight: 0.2,
    motionLookbackMs: 150,
    minVisibility: 0.5,
};
export const DEFAULT_BODY_PART_WEIGHTS = {
    leftArm: 0.2,
    rightArm: 0.2,
    leftLeg: 0.175,
    rightLeg: 0.175,
    torso: 0.25,
};
export const DEFAULT_GRADING_CONFIG = {
    gradeWindowMs: 1000,
    trimFraction: 0.2,
    thresholds: { perfect: 88, great: 75, good: 60 },
    gradePoints: { perfect: 100, great: 70, good: 40, miss: 0 },
    comboStep: 0.02,
    comboCap: 1.5,
};
export const DEFAULT_FRAMING_CONFIG = {
    minVisibility: 0.5,
    requiredConsecutiveFrames: 10,
    lostAfterMs: 1000,
};
//# sourceMappingURL=config.js.map